<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月12日 11:22:57 +0800
 * @最后修改时间: 2021-12-13 16:49:50
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\PunchCriteriaType\components\newMapping.vue
 -->
<template>
  <normalDialog
    width="680"
    maxWidth="680"
    @close="closeDialog"
    :title="
      $t('label_essweb_punchCriteriaType_list_dialog_newCriteriaTypeTitle')
    "
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t(
                "label_essweb_punchCriteriaType_list_dialog_punchCriteriaTypeeLabel"
              )
            }}</v-sheet>
            <v-autocomplete
              :items="AllType"
              item-text="criteria_type_name"
              item-value="punch_code"
              dense
              :rules="$GetRules(['_Require_Rules'], [null])"
              filled
              :placeholder="
                $t(
                  'label_essweb_punchCriteriaType_list_dialog_punchCriteriaTypeeLabel'
                )
              "
              v-model="PunchData.punch_code"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template>
              <template v-slot:selection="data">
                {{ $t(data.item.criteria_type_name) }}
              </template>
              <template v-slot:item="data">
                <div class="table-title text--primary">
                  {{ $t(data.item.criteria_type_name) }}
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="PunchData.criteria_type_name"
              maxlength="100"
              :TrigerInit="show"
              @change="
                (valueArr) => {
                  PunchData.criteria_type_name = valueArr;
                }
              "
              :label="
                $t(
                  'label_essweb_punchCriteriaType_list_dialog_punchCriteriaNameLabel'
                )
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="PunchData.criteria_type_description"
              maxlength="500"
              :TrigerInit="show"
              @change="
                (valueArr) => {
                  PunchData.criteria_type_description = valueArr;
                }
              "
              :label="
                $t(
                  'label_essweb_punchCriteriaType_list_dialog_descriptionLabel'
                )
              "
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <inputTextFiledMultiLang
              :bindData="PunchData.criteria_type_abbr"
              maxlength="20"
              :TrigerInit="show"
              @change="
                (valueArr) => {
                  PunchData.criteria_type_abbr = valueArr;
                }
              "
              :label="
                $t('label_essweb_punchCriteriaType_list_dialog_abbrLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_punchCriteriaType_list_dialog_tableNameLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="AllTable"
              item-text="view_fields"
              item-value="value_field"
              dense
              :disabled="true"
              :rules="$GetRules(['_Require_Rules'], [null])"
              filled
              append-icon
              :placeholder="
                $t('label_essweb_punchCriteriaType_list_dialog_tableNameLabel')
              "
              v-model="PunchData.table_name"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template>
              <template v-slot:selection="data">
                {{ $getCommonLangValue(data.item.view_fields) }}
              </template>
            </v-autocomplete>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchCriteriaType_list_dialog_viewNameLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="AllView"
              item-text="f3"
              item-value="value_field"
              dense
              filled
              :placeholder="
                $t('label_essweb_punchCriteriaType_list_dialog_viewNameLabel')
              "
              v-model="PunchData.view_name"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t(
                "label_essweb_punchCriteriaType_list_dialog_containerNameLabel"
              )
            }}</v-sheet>
            <v-autocomplete
              :items="AllContainer"
              item-text="f3"
              item-value="value_field"
              dense
              filled
              :placeholder="
                $t(
                  'label_essweb_punchCriteriaType_list_dialog_containerNameLabel'
                )
              "
              v-model="PunchData.container_name"
              single-line
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col> -->
          <!-- // 2021-04-25 删掉图标 brain -->
          <!-- <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchCriteriaType_list_dialog_iconLabel")
            }}</v-sheet>
            <ImgDragUpdate
              @change="(img) => (PunchData.attachment_uuid = img)"
              single
            />
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchCriteriaType_list_dialog_remarkLabel")
            }}</v-sheet>
            <v-text-field
              dense
              filled
              maxlength="500"
              single-line
              :label="
                $t('label_essweb_punchCriteriaType_list_dialog_remarkLabel')
              "
              :placeholder="
                $t('label_essweb_punchCriteriaType_list_dialog_remarkLabel')
              "
              v-model="PunchData.remarks"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="onNewProperty" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newMappingDialog",
  props: ["show"],
  computed: {
    ...mapGetters(["companyLang"]),
  },
  data() {
    return {
      AllType: [
        {
          punch_code: "GPS",
          criteria_type_name: "label_essweb_punchManage_list_tab_gpsLabel",
        },
        {
          punch_code: "WIFI",
          criteria_type_name: "label_essweb_punchManage_list_tab_wifiLabel",
        },
        {
          punch_code: "BLUETOOTH",
          criteria_type_name:
            "label_essweb_punchManage_list_tab_bluetoothLabel",
        },
      ],
      AllView: [],
      AllTable: [
        "ess_punch_criteria_gps",
        "ess_punch_criteria_wifi",
        "ess_punch_criteria_bluetooth",
      ],
      AllContainer: [],
      PunchData: {
        punch_code: "",
        criteria_type_name: "",
        view_name: "",
        container_name: "",
        criteria_type_abbr: "",
        criteria_type_description: "",
        table_name: "",
        attachment_uuid: null,
        remarks: "",
      },
    };
  },
  watch: {
    show(val) {
      const that = this;
      if (val) {
        this.PunchData = {
          punch_code: "",
          criteria_type_name: "",
          view_name: "",
          container_name: "",
          criteria_type_abbr: "",
          criteria_type_description: "",
          table_name: "",
          attachment_uuid: null,
          remarks: "",
        };
        this.$nextTick(() => {
          if (this.$refs["form"]) this.$refs["form"].reset();
        });
      }
    },
    "PunchData.punch_code": function (val) {
      const that = this;
      switch (val) {
        case "GPS":
          that.PunchData.table_name = "ess_punch_criteria_gps";
          break;
        case "WIFI":
          that.PunchData.table_name = "ess_punch_criteria_wifi";
          break;
        case "BLUETOOTH":
          that.PunchData.table_name = "ess_punch_criteria_bluetooth";
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.PunchData.criteria_type_name = this.$getCommonLangKey(
      this.companyLang
    );
    this.PunchData.criteria_type_description = this.$getCommonLangKey(
      this.companyLang
    );
    this.PunchData.criteria_type_abbr = this.$getCommonLangKey(
      this.companyLang
    );
    this.getTable();
  },
  methods: {
    getTable() {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_punch_criteria_table_select",
      }).then((res) => {
        that.AllTable = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close", false);
    },
    onNewProperty: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }

      this.$emit("onNewProperty", this.PunchData);
    },
  },
};
</script>
